/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
    CardTitle,
    Badge,
    Card,
    Row,
    Col,
    CardBody,
    Button,
    CardHeader,
    Label,
    Input,
    Container,
    FormGroup,
    Collapse,
} from "reactstrap";
import axios from "axios";
import SimpleHeaderMobile from "components/Headers/SimpleHeaderMobile";
import "../Style.css";
import { Link } from "react-router-dom";

const IndexHistorySales = () => {
    const warehouse = localStorage.warehouse;
    const token = localStorage.token;
    const username = localStorage.username;

    const [allDokumenCanvaser, setAllDokumenCanvaser] = useState([]);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [tanggal1, setTanggal1] = useState("");
    const [tanggal2, setTanggal2] = useState("");
    const [collapse, setCollapse] = useState(false);
    const redirectPrefix = `/mobile/canvasing/history/detail/`;

    const toggle = () => setCollapse(!collapse);

    // Fetch Data
    const getAsset = (page, search_date1 = null, search_date2 = null) => {
        const filter = {
            page,
            per_page: 500,
            start_date: search_date1 || tanggal1,
            end_date: search_date2 || tanggal2,
            warehouse_id: parseInt(warehouse),
            username: username,
        };

        const headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        };

        axios
            .post(
                `${process.env.REACT_APP_API_BASE_URL}/canvasing/page`,
                filter,
                { headers }
            )
            .then((res) => {
                const responseData = res.data.response || [];
                setAllDokumenCanvaser(responseData);
                setPage(res.data.current_page + 1);
                setPerPage(res.data.per_page);
            })
            .catch((error) => {
                console.error(error);
                setAllDokumenCanvaser([]);
            });
    };

    useEffect(() => {
        getAsset(page, tanggal1, tanggal2);
    }, []);

    // Reset Filter
    const reset = () => {
        setTanggal1("");
        setTanggal2("");
        getAsset(1, "");
    };

    const getStatusColor = (approve) => {
        switch (approve) {
            case 3:
                return "#ffc107"; // Kuning untuk pending
            case 4:
                return "#dc3545"; // Merah untuk ditolak
            default:
                return "#28a745"; // Hijau untuk disetujui
        }
    };

    const getStatusIcon = (approve) => {
        switch (approve) {
            case 3:
                return "fa-question"; // Tanda tanya untuk pending
            case 4:
                return "fa-times"; // Tanda silang untuk ditolak
            default:
                return "fa-check"; // Centang untuk disetujui
        }
    };

    return (
        <div style={{ overflow: "hidden" }}>
            <SimpleHeaderMobile to="/mobile/sales/page" judul="Histori Kehadiran" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            {/* <CardHeader>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                    }}
                                >
                                    <h3>Riwayat Canvaser</h3>
                                    <Button
                                        color="link"
                                        onClick={toggle}
                                        style={{ marginBottom: "1rem" }}
                                    >
                                        {collapse ? (
                                            <i className="fa fa-minus" aria-hidden="true"></i>
                                        ) : (
                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                        )}
                                    </Button>
                                </div>
                                <Collapse isOpen={collapse}>
                                    <div style={{ textAlign: "left" }}>
                                        <Row className="row-cols-lg-auto g-3 align-items-center">
                                            <Col>
                                                <FormGroup>
                                                    <Label className="form-control-label">
                                                        Pilih Tanggal
                                                    </Label>
                                                    <Input
                                                        autoComplete="off"
                                                        type="date"
                                                        value={tanggal}
                                                        onChange={(e) => setTanggal(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col>
                                                <Label>&nbsp;</Label>
                                                <Button
                                                    type="button"
                                                    onClick={() => getAsset(page, tanggal)}
                                                    className="btn btn-info"
                                                >
                                                    <i className="fa fa-filter"></i>
                                                </Button>
                                            </Col>
                                            <Col>
                                                <Label>&nbsp;</Label>
                                                <Button
                                                    type="button"
                                                    onClick={reset}
                                                    className="btn btn-secondary"
                                                >
                                                    Reset
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Collapse>
                            </CardHeader> */}
                            <CardHeader>
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 className="mb-0">Histori Canvaser</h3>
                                    <Button
                                        color="link"
                                        onClick={toggle}
                                        className="p-0"
                                    >
                                        {collapse ? (
                                            <i className="fa fa-minus" aria-hidden="true"></i>
                                        ) : (
                                            <i className="fa fa-plus" aria-hidden="true"></i>
                                        )}
                                    </Button>
                                </div>

                                <Collapse isOpen={collapse}>
                                    <div className="mt-3">
                                        <Row className="gx-2 gy-2">
                                            <Col xs="12" md="4">
                                                <FormGroup>
                                                    <Label className="form-control-label">Pilih Awal</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        type="date"
                                                        value={tanggal1}
                                                        onChange={(e) => setTanggal1(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="12" md="4">
                                                <FormGroup>
                                                    <Label className="form-control-label">Pilih Akhir</Label>
                                                    <Input
                                                        autoComplete="off"
                                                        type="date"
                                                        value={tanggal2}
                                                        onChange={(e) => setTanggal2(e.target.value)}
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col xs="6" md="2" className="d-flex align-items-end">
                                                <Button
                                                    type="button"
                                                    onClick={() => getAsset(page, tanggal1, tanggal2)}
                                                    className="btn btn-info w-100"
                                                >
                                                    <i className="fa fa-filter" />
                                                </Button>
                                            </Col>
                                            <Col xs="6" md="2" className="d-flex align-items-end">
                                                <Button
                                                    type="button"
                                                    onClick={reset}
                                                    className="btn btn-secondary w-100"
                                                >
                                                    Reset
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Collapse>
                            </CardHeader>


                            {allDokumenCanvaser.length === 0 ? (
                                <CardBody>
                                    <center>
                                        <h3>DATA NOT FOUND</h3>
                                    </center>
                                </CardBody>
                            ) : (
                                <div
                                    style={{
                                        height: "73vh",
                                        overflowY: "auto",
                                        cursor: "pointer",
                                        padding: "1rem", // Tambahkan padding untuk memberikan ruang
                                    }}
                                >
                                    {allDokumenCanvaser.map((v, index) => (
                                        <Link
                                            to={redirectPrefix + v.canvasing_code}
                                            id={"tooltip_" + v.canvasing_code}
                                            key={index} // Pastikan setiap elemen memiliki key unik
                                            style={{ textDecoration: "none", color: "inherit" }} // Hapus underline link
                                        >
                                            {/* Kartu Utama */}
                                            <Card
                                                style={{
                                                    marginBottom: "1rem",
                                                    borderRadius: "10px", // Sudut melengkung
                                                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Bayangan halus
                                                    transition: "transform 0.2s, box-shadow 0.2s", // Animasi hover
                                                }}
                                                className="hover-card"
                                            >
                                                <CardBody
                                                    style={{
                                                        display: "flex",
                                                        alignItems: "center", // Vertikal tengah
                                                        justifyContent: "space-between", // Ruang antara konten
                                                        padding: "1rem", // Padding dalam kartu
                                                    }}
                                                >
                                                    {/* Kolom Kiri (Informasi Customer) */}
                                                    <Col style={{ flex: 1 }}>
                                                        {/* Nama Customer */}
                                                        <CardTitle
                                                            className="h5 text-uppercase mb-1"
                                                            style={{
                                                                fontWeight: "bold",
                                                                color: "#333", // Warna teks lebih gelap
                                                            }}
                                                        >
                                                            {v.customer_name}
                                                        </CardTitle>

                                                        {/* Nama Proyek */}
                                                        <div
                                                            className="text-black font-weight-bold"
                                                            style={{
                                                                fontSize: "0.9rem",
                                                                color: "#555", // Warna teks abu-abu gelap
                                                            }}
                                                        >
                                                            {v.nama_proyek ?? "-"}
                                                        </div>

                                                        {/* Tanggal */}
                                                        <div
                                                            className="text-sm mt-1"
                                                            style={{
                                                                fontSize: "0.8rem",
                                                                color: "#777", // Warna teks abu-abu muda
                                                            }}
                                                        >
                                                            <i className="fa fa-calendar mr-1" />
                                                            {v.created_at ?? "Tanggal tidak tersedia"}
                                                        </div>
                                                    </Col>

                                                    {/* Kolom Kanan (Status Approve) */}
                                                    <Col className="col-auto">
                                                        <div
                                                            style={{
                                                                width: "40px",
                                                                height: "40px",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                borderRadius: "50%", // Lingkaran penuh
                                                                backgroundColor: getStatusColor(v.approve), // Warna dinamis berdasarkan status
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Bayangan halus
                                                            }}
                                                        >
                                                            <i
                                                                className={`fa ${getStatusIcon(v.approve)}`}
                                                                style={{
                                                                    fontSize: "1rem",
                                                                    color: "#fff", // Ikon putih
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </CardBody>
                                            </Card>
                                        </Link>
                                    ))}
                                </div>
                            )}
                        </Card>
                    </div>
                </Row>
            </Container>
        </div>
    );
};

export default IndexHistorySales;
